import { render, staticRenderFns } from "./CollectionMailReview.vue?vue&type=template&id=f813f3de&"
import script from "./CollectionMailReview.vue?vue&type=script&lang=ts&"
export * from "./CollectionMailReview.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionMailReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports